import React from "react";
import "./style.scss";
import SelectAddOn from "../../../components/Seggregation/SelectAddOn";
const SelectAddOnPage = () => {
  return (
    <div className="select_add_on_page_wrapper">
      <SelectAddOn />
    </div>
  );
};
export default SelectAddOnPage;
